import { calculateLastDayOfMonth, formatDate } from "utils/calendarDateFormatting";

// Student bez uloženého data vzniku plánu — kalendář od začátku školního roku 2023/24.
const FALLBACK_CALENDAR_START = "2023-09-01";

// Jak staré (v sekundách) smí být data kalendáře z cache, aby se při otevření stránky nestahovala znovu.
// Společné pro `refetchOnMountOrArgChange` stránky a `ifOlderThan` prefetche — rozcházet se nesmí.
export const CALENDAR_DATA_MAX_AGE_S = 30;

/**
 * Rozsah dotazu `getTimetable` pro kalendář (`/kalendar`).
 *
 * AIDEV-NOTE: Jediné místo, kde se rozsah počítá. Stránka kalendáře, prefetch z menu a prefetch
 * při studeném startu v `AuthenticatedArea` musí poslat PŘESNĚ stejné argumenty, jinak RTK Query
 * pro ně vytvoří jiný cache klíč a dotaz poletí dvakrát. [TD-476]
 */
export const getCalendarRange = (timetableCreateDate: string | null | undefined, admissionsDeadline: string) => {
  const startDate =
    typeof timetableCreateDate === "string" ? new Date(timetableCreateDate) : new Date(FALLBACK_CALENDAR_START);
  const lastDate = calculateLastDayOfMonth(admissionsDeadline);

  return { dateFrom: formatDate(startDate), dateTo: formatDate(lastDate) };
};
